import React, { useEffect, useState } from "react";
import ImageWithFallback from "common/components/ImageWithFallback/ImageWithFallback";
import app_params from "modules/search/config/params";
import { useParams } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import styles from './RecordDetail.module.scss'
import { Alert, Button ,Collapse} from "react-bootstrap";
import Axios from 'services/BackendApi/BackendApi';
import QuoteModal from "../QuoteModal/QuoteModal";
import GlifosDigitalArchiveViewer from 'modules/catalog/components/GlifosDigitalArchiveViewer/GlifosDigitalArchiveViewer'
import ShareModal from "../ShareModal/ShareModal";
import image from 'assets/icono.jpg'
import icon from 'assets/img/document-icon.png'
import { searchService } from "services/BackendApi/searchService";
import { Eye } from "react-bootstrap-icons";


export default function RecordDetail(props) {
  const { id } = useParams();
  const { record, flag } = props;
  const bearer = localStorage.getItem("userInfo");
  const token = JSON.parse(bearer).access_token;
  const [titulo, setTitulo] = useState("Documentos Relacionados");
  const [showReferences, setShowReferences] = useState(false);
  const [tags, setTags] = useState({ tags: [], loaded: false });
  const [show, setShow] = useState(false);
  const [searchargs, setSearchArgs] = useState();
  const [nodo, setNodo] = useState();
  const [showRevision, setShowRevision] = useState(false);
  const [reviewedBy, setReviewedBy] = useState();
  const [reviewedAt, setReviewedAt] = useState();
  const [showMini, setShowMini] = useState(false);
  const [nameMini, setNameMini] = useState(false);
  const [docytpes, setDoctypes] = useState([]);
  const [mostrarMas, setMostrarMas] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [searchResult, setSearchResult] = useState({
    loading: true,
    error: false,
    result: {},
  });

  const handleClose = () => setShow(false);
  const handleCloseMini = () => setShowMini(false);

  const handleShowMini = (name) => {
    validate(3)
    setShowMini(true);
    setNameMini(name)
  };

  const handleShow = () => {
    validate(3)
    setShow(true);
  };
  
  useEffect(() => {
    setSearchArgs(window.location.search)
    viewAdmin()
    console.log(record)
    if (record) {
      getData(record)
      if (record?.fileid == undefined) {
        setDeshabilitado(true)
      }
      setReviewedBy(record?.reviewed_by)
      setNodo(record?.nodo)
      setReviewedAt(record?.reviewed_at)
      // aux.identifiers.value = aux.identifiers.value.filter(identifier => identifier.label !== "Referencia");
      const tags = Object.entries(record).flatMap(([key, value]) => {
        if (Array.isArray(value)) {
          return [...value.map(item => ({ name: item.label, subfields: { value: item.value } }))]
        } else {
          if (Array.isArray(value.value)) {
            return [...value.value.map(item => ({ name: item.label, subfields: { value: item.value } }))]
          }
          return { name: value.label, subfields: { value: value.value } }
        }
        return {}
      }).filter(item => item.name);
      // console.log(tags);

      setTags({ tags: tags, loaded: true });
    } else {
      setTags({ tags: [], loaded: true });
    }
  }, []);

  const manejarClick = () => {
    setMostrarMas(!mostrarMas);
  };

  const elementosFiltrados = tags?.tags?.filter(tag_value => tag_value.name !== "Referencia") || [];
  const elementosVisibles = elementosFiltrados.slice(0, 10);
  const elementosOcultos = elementosFiltrados.slice(10);

  function viewAdmin() {
    const user = localStorage.getItem("userInfo");
    const roles = JSON.parse(user).roles;
    console.log(roles)
    if (roles.includes("administrator")) {
      setShowRevision(true)
    }
  }

  async function getData(datos) {
    let docs = await Axios.GetDocTypes({ urlParams: "1" });
    const codes = docs?.data.map(item => item.code);
    var tipo = datos.hierarchy.find(item => item.label === "Tipo Documento").value;
    let permission = codes.includes(tipo);
    var master = datos.identifiers.value.find(item => item.label === "Id clave");
    var references = datos.identifiers.value.find(item => item.label === "Referencia");
    if (master != undefined) {
      setShowReferences(true)
      let res = await searchService("?typefiedid=reference-" + master.value);//?hierarchy=&doctype=C8&typefiedid=bank-account-313-001137-9&documentdatei=&documentdatef=&identifier=&fulltext=
      let doc = await Axios.GetAllDocTypes({ urlParams: "1" });
      setDoctypes(doc.data)
      // console.log(res)
      if (res?.success == "true") {
        if (!Array.isArray(res.records?.record)) {
          res.records.record = [res?.records.record];
        }
        setSearchResult({
          loading: false,
          error: false,
          result: {
            result_header: res?.result_header,
            records: res?.records.record,
          },
        });
      }
    }
    else if (references != undefined) {
      setShowReferences(true)
      // setTitulo("Documento principal")
      let res = await searchService("?typefiedid=reference-" + references.value);//?hierarchy=&doctype=C8&typefiedid=bank-account-313-001137-9&documentdatei=&documentdatef=&identifier=&fulltext=
      console.log(res)
      let doc = await Axios.GetAllDocTypes({ urlParams: "1" });
      // setDoctypes(doc.data)
      let filteredRecords = "";
      if (res?.success == "true") {
        if (!Array.isArray(res.records?.record)) {
          filteredRecords = res?.records.record.filter(record => record.title !== id);

          res.records.record = [filteredRecords];
        }
        filteredRecords = res?.records.record.filter(record => record.title !== id);
        setSearchResult({
          loading: false,
          error: false,
          result: {
            result_header: res?.result_header,
            records: filteredRecords,
          },
        });
      }
    }
    if (permission == false) {
      if (flag === 'true') {
        validate(4)
        window.location.href = '/archive/catalog/search';
      } else {
        validate(2)
        window.location.href = '/archive/catalog/search';
      }
    }
    else {
      if (flag === 'true') {
        handleShow()
      } else {
        validate(1)
      }
    }
  }

  const [items, setItems] = useState([]);

  useEffect(() => {
    const storedItems = localStorage.getItem('items');
    // console.log(storedItems)
    if (storedItems) {
      setItems(JSON.parse(storedItems));
    }
  }, []);

  useEffect(() => {
    // console.log(items)
    localStorage.setItem('items', JSON.stringify(items));
  }, [items]);



 
  async function addDossier () {
    // console.log(id)
    let doc = await Axios.GetNodeForDossier({ urlParams: {id} });
    if (items.some(item => item.id === doc.data.id)) {
      const updatedItems= items.filter(item => item.id !== doc.data.id);
      setItems(updatedItems);
    } else {
      setItems([...items, doc.data]);
    }
  };



  async function validate(auth) {
    try {
      let res = await Axios.GetRevision({ urlParams: { id: id, auth: auth } });
      console.log(res)
    } catch (error) {
      console.error(error);
    }

  }

  function buscarNombrePorCodigo(codigo) {
    const elemento = docytpes.find(item => item.code === codigo);
    return elemento ? elemento.name : codigo;
  }

  return (
    <>
      <div className="col-12 col-lg-3">
        <div className="row text-lg-center">
          <div className="col-5 col-lg-12 mb-2 py-2">
            <a className={styles.thumb}>
              <ImageWithFallback
                onClick={!deshabilitado ? handleShow : null}
                className="img-thumbnail rounded w-80 w-md-50 w-lg-75"
                fallback={image}
                src={"/api/v1/file/get-thumbnail/" + record?.fileid}
                token={token}
              />
            </a>
          </div>
          <div className="col-7 col-lg-12">
            <div className="row d-flex flex-column justify-content-center h-75">
              <div className="col-12">
                {/* {record?.preview_file !== "null" && (
                  <a
                    className="btn btn-sm btn-outline-secondary col-12 mb-2"
                    href={record?.preview_file}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="me-2">
                      <i className="fas fa-align-left"></i>
                    </span>
                    Contenido
                  </a>
                )}
                <button
                  className="btn btn-sm btn-outline-secondary col-12  mb-2"
                  data-bs-toggle="modal"
                  data-bs-target={`#shareModal-${id}`}
                >
                  <span className="me-2">
                    <FaShareAlt />
                  </span>
                  Compartir
                </button>*/}
                <br />
                {(!deshabilitado) ?
                  <Button onClick={handleShow}>Ver Documento</Button>
                  :
                  null
                }
                {(reviewedBy != null) && (showRevision == true) && (
                  <>
                    <br />
                    <b>Revisado por:</b> {reviewedBy}
                    <br />
                    <b>Cuando:</b> {reviewedAt}
                  </>
                )}
                {/* <Button
                  className="btn btn-sm btn-outline-secondary col-8"
                  data-bs-toggle="modal"
                  data-bs-target={`#quoteModal-${id}`}
                  variant="primary"
                // className={styles.text}
                >
                  <span className="me-2">
                    <BoxArrowDown />
                  </span>
                  Descargar Documento
                </Button> */}
              </div>
            </div>
            {/* <div className="d-lg-none d-flex flex-row-reverse">
              <Button variant="primary">Ver Documento</Button>
            </div> */}
            {/* <MarcCheck showMARC={showMARC} setShowMARC={setShowMARC} /> */}
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-9">
        <div className="row mb-2">
          
          <div className="col-7">
            <h2>{id}</h2>
            {tags.loaded && (
              <>
                <div>
                  {elementosVisibles.map((tag_value, index) => (
                    <div className="row mb-1" key={index}>
                      <div className="col-7 col-md-6 col-lg-6 col-xxl-5">
                        <b>{tag_value.name}</b>:
                      </div>
                      <div className="col-5 col-md-6 col-lg-7 col-xxl-7 text-break">
                        {Array.isArray(tag_value?.subfields?.value) ? (
                          <>
                            {tag_value?.subfields?.value.join(" hasta ")}
                          </>
                        ) : (
                          <>{tag_value?.subfields?.value}</>
                        )}
                      </div>
                    </div>
                  ))}

                  {elementosOcultos.length > 0 && (
                    <div>

                      {/* {mostrarMas && ( */}
                         <Collapse in={mostrarMas}>
                        <div>
                          {elementosOcultos.map((tag_value, index) => (
                            <div className="row mb-1" key={index + 10}>
                              <div className="col-7 col-md-6 col-lg-6 col-xxl-5">
                                <b>{tag_value.name}</b>:
                              </div>
                              <div className="col-5 col-md-6 col-lg-7 col-xxl-7 text-break">
                                {Array.isArray(tag_value?.subfields?.value) ? (
                                  <>
                                    {tag_value?.subfields?.value.join(" hasta ")}
                                  </>
                                ) : (
                                  <>{tag_value?.subfields?.value}</>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                         </Collapse>
                      {/* )} */}
                      {mostrarMas ? '':<b>...<br /></b>}
                      <Button onClick={manejarClick}>
                        {mostrarMas ? 'Mostrar menos' : 'Mostrar más'}
                      </Button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="col-5 d-none d-lg-flex flex-row-reverse py-2">
            {/* <MarcCheck showMARC={showMARC} setShowMARC={setShowMARC} /> */}
            {(!deshabilitado) ?
              <div >
              <Button className={styles.buttons} onClick={()=>addDossier(record)} variant={(items.some(item => item.id === nodo) == true)?"danger":"warning"}>{(items.some(item => item.id === nodo) == true)?"Eliminar de Expediente":"Agregar a expediente"}</Button>
              <Button className={styles.buttons} onClick={handleShow} >Ver Documento</Button>
              </div>
              :
              null
            }
          </div>
          {(showReferences == true ?

            <div className="col-5">

              <h3>{titulo}</h3>
              <div className="col-8">

                {searchResult.result.records?.map((elemento, index) => (
                  <div className={styles.documents}>
                    <div className="row bg-white p-sm-2 mb-5 shadow-sm rounded" key={index}>

                      <div className={`col-4 ${styles.icono}`}>

                        <img src={icon} style={{ width: '50px', height: '50px', textAlign: 'center' }} alt='icono' />
                        <p>{buscarNombrePorCodigo(elemento?.doctype)}</p>
                      </div>
                      <div className="col-8">
                        <a href={`${app_params.basepath}/view/false/${elemento?.title}${searchargs}`} className="text-decoration-none" target="_blank">
                          <div className={styles.documentTitle}>
                            {elemento?.title}
                          </div>
                        </a>
                        <Button className={styles.boton} onClick={() => handleShowMini(elemento)}><Eye /> </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> : null
          )}
        </div>
      </div>
      <QuoteModal modalID={`quoteModal-${id}`} item={{ id }} />
      <ShareModal
        id={`shareModal-${id}`}
        url={`${window.location.origin}${app_params.basepath}/record/${id}`}
        quote={record?.share_quote}
      />

      <Modal show={show} onHide={handleClose} fullscreen={true} className={styles.modal} >
        <Modal.Header closeButton>
          <Modal.Title>{id}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.columna}>
          <GlifosDigitalArchiveViewer src={"/api/v1/file/get-file/" + record?.fileid} token={token} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={()=>addDossier(record)} variant={( items.some(item => item.id === nodo) == true)?"danger":"warning"}>{( items.some(item => item.id === nodo) == true)?"Eliminar de Expediente":"Agregar a expediente"}</Button>

        </Modal.Footer>
      </Modal>

      <Modal show={showMini} onHide={handleCloseMini} fullscreen={true} className={styles.modal} >
        <Modal.Header closeButton>
          <Modal.Title>{nameMini.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.columna}>
          <GlifosDigitalArchiveViewer src={"/api/v1/file/get-file/" + nameMini?.thumbnail?.split('/')[5]} token={token} />
        </Modal.Body>
      </Modal>
    </>
  );
}
